"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Grid_1 = require("@material-ui/core/Grid");
var Typography_1 = require("@material-ui/core/Typography");
var withStyles_1 = require("@material-ui/styles/withStyles");
var styles_1 = require("./styles");
var RequiredFieldsNotice = function (_a) {
    var classes = _a.classes;
    return (React.createElement(Grid_1.default, { item: true, className: classes.requiredFieldNotice },
        React.createElement(Typography_1.default, { color: "textSecondary", variant: "caption" }, "* required")));
};
exports.default = withStyles_1.default(styles_1.default)(RequiredFieldsNotice);
